import { useManagePageQueryParams } from '@/hooks/queryParams/useManagePageQueryParams'
import { Avatar, Flex, Text, Title } from '@collable/ui'

const ManageChannelHeader = () => {
  const { selectedChannel } = useManagePageQueryParams()
  return (
    <Flex direction="column" gap={20}>
      <Flex gap={16} alignItems="center">
        <Avatar size="xl" type="creator" src={selectedChannel?.channelThumbnail} />
        <Title size="subTitle1" color="labelStrong" fontWeight="bold" as="h1">
          {selectedChannel?.channelName || selectedChannel?.email}
        </Title>
      </Flex>
      <Flex direction="column" gap={2}>
        <Title size="subTitle1" fontWeight="bold" as="h2">
          내 채널 정보
        </Title>
        <Text size="body2" color="labelAssistive">
          채널에 대한 자세한 정보를 입력해요
        </Text>
      </Flex>
    </Flex>
  )
}

export default ManageChannelHeader
